import { NumericFormat } from 'react-number-format';

const formatUSD = (
  value: number | string,
  decimalScale: number = 2,
  suffix = ' USD',
  prefix = '',
) => {
  return (
    <NumericFormat
      value={value.toString()}
      displayType="text"
      thousandSeparator={' '}
      decimalScale={decimalScale}
      suffix={suffix}
      prefix={prefix}
      fixedDecimalScale
      renderText={(formattedValue) => formattedValue}
    />
  );
};

export default formatUSD;
